import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Analytics from './Analytics/Analytics';
import CouponsVouchers from './CouponsVouchers/CouponsVouchers';
import GeographicBoundary from './GeographicBoundary';
import GroundStaffs from './GroundStaffs';
import Page from './Page/Page';
import Post from './Post/Post';
import PostsListing from './Post/Listing/PostsListing';
import FoodReviewHighlight from './PageHighlight/FoodReview';
import GenericHighlight from './PageHighlight/Generic';
import Gift from './CouponsVouchers/List/Gift/Gift';
import PageHighlightListing from './PageHighlight/Listing';
import PageHighlight from './PageHighlight/PageHighlight';
import PageNotFound from '../../components/PageNotFound';
import { Url } from '../../common/constants';
import Profile from './Profile/Profile';
import OutletsListing from './Outlets/OutletsListing';
import Access from './Access/Access';
import Outlet from './Outlets/Outlet/Outlet';
import Account from './Account/Account';
import Business from './Business';
import BusinessProfile from './BusinessProfile';
import CreatePageClaim from './PageClaim/CreatePageClaim';
import Support from './Support';
import Invitation from './Invitation';
import PageClaimView from './PageClaim/PageClaimView';
import AccessDenied from '../../components/AccessDeniedComp';
import { IsAdminOrContributor, IsAdminOnly, IsPhotographerPage } from '../../common/checks';
import Review from './Review/Review';
import ReviewsListing from './Review/Listing/ReviewsListing';
import Locations from './Review/Locations/Locations';
import LoyaltyProgram from './LoyaltyProgram/LoyaltyProgram';
import LoyaltyCards from './LoyaltyProgram/LoyaltyCards';
import PromoCodes from './LoyaltyProgram/PromoCodes/PromoCodes';
import CouponVoucherTracking from './CouponsVouchers/CouponVoucherTracking/CouponVoucherTracking';
import LoyaltyCardsCustomers from './LoyaltyProgram/LoyaltyCardsCustomers';
import Albums from './Photos/Albums';
import AlbumDetails from './Photos/AlbumDetails';
import AlbumPhotosAdd from './Photos/AlbumPhotosAdd';
import Snapstyr from './Photos/Snapstyr';
import Settings from './Settings';
import SnapstyrAdd from './Photos/SnapstyrAdd';

const BusinessRoutes = ({ match, history, page }) => (
  <Switch>
    {/** When page is selected, default we show Posts Listing */}
    <Route
      exact
      path={Url.Page}
      render={() => (
        <Redirect to={
          (IsPhotographerPage(page?.pageType))
            ? Url.Snapstyr.replace(':pageId', match.params.pageId)
            : Url.Posts.replace(':pageId', match.params.pageId)
        }
        />
      )}
    />
    <Route exact path={Url.Business} render={() => <Business />} />
    <Route
      exact
      path={Url.Access}
      render={() => {
        if (IsAdminOnly(page.staffType)) {
          return <Access />;
        } else {
          return <AccessDenied />;
        }
      }}
    />
    <Route
      exact
      path={Url.Account}
      render={() => {
        if (IsAdminOrContributor(page.staffType)) {
          return <Account />;
        } else {
          return <AccessDenied />;
        }
      }}
    />
    <Route exact path={Url.Analytics} render={() => <Analytics />} />
    <Route exact path={Url.Albums} component={Albums} />
    <Route exact path={Url.AlbumDetails} component={AlbumDetails} />
    <Route exact path={Url.BusinessProfile} component={BusinessProfile} />
    <Route exact path={Url.CreatePageClaim} render={() => <CreatePageClaim />} />

    <Route exact path={Url.CouponsAndVouchers} component={CouponsVouchers} />
    <Route exact path={Url.CouponVoucherTracking} component={CouponVoucherTracking} />
    <Route exact path={Url.FoodReviewHighlight} component={FoodReviewHighlight} />

    <Route exact path={Url.GenericHighlight} component={GenericHighlight} />
    <Route exact path={Url.GeographicBoundary} component={GeographicBoundary} />
    <Route exact path={Url.Gift} component={Gift} />
    <Route exact path={Url.GroundStaffs} component={GroundStaffs} />

    <Route exact path={Url.Invitation} render={() => <Invitation />} />

    <Route exact path={Url.LoyaltyCard} component={LoyaltyProgram} />
    <Route exact path={Url.LoyaltyCards} component={LoyaltyCards} />
    <Route exact path={Url.LoyaltyCardsCustomers} component={LoyaltyCardsCustomers} />
    <Route exact path={Url.LoyaltyCardInfo} component={LoyaltyProgram} />
    <Route exact path={Url.LoyaltyCardAnalytics} component={LoyaltyProgram} />
    <Route exact path={Url.MapSettings} component={LoyaltyProgram} />

    <Route exact path={Url.Outlets} component={OutletsListing} />
    <Route exact path={Url.Outlet} component={Outlet} history={history} />

    <Route exact path={Url.PromoCodes} component={PromoCodes} match={match} />

    <Route exact path={Url.PageClaimView} component={PageClaimView} />
    <Route exact path={Url.PageInfo} component={Page} />
    <Route path={Url.PageHighlight} component={PageHighlight} />
    <Route exact path={Url.PageHighlightListing} component={PageHighlightListing} />
    <Route exact path={Url.PlaceLocation} component={Locations} />
    <Route exact path={Url.Post} component={Post} />
    <Route exact path={Url.Posts} component={PostsListing} history={history} />
    <Route exact path={Url.Profile} render={() => <Profile />} />

    <Route exact path={Url.Review} component={Review} />
    <Route exact path={Url.Reviews} component={ReviewsListing} history={history} />
    <Route exact path={Url.Settings} component={Settings} />

    <Route exact path={Url.Snapstyr} component={Snapstyr} />
    <Route exact path={Url.SnapstyrAdd} component={SnapstyrAdd} />
    <Route exact path={Url.AlbumPhotosAdd} component={AlbumPhotosAdd} />

    <Route exact path={Url.StampSettings} component={LoyaltyProgram} />
    <Route exact path={Url.Support} component={Support} />

    <Route path="/*" render={(props) => <PageNotFound {...props} />} />
  </Switch>
);

BusinessRoutes.propTypes = {
  match: PropTypes.shape({
    path:   PropTypes.string.isRequired,
    params: PropTypes.shape({
      businessId: PropTypes.string,
      pageId:     PropTypes.string,
    }),
  }).isRequired,

  history: PropTypes.shape(Object).isRequired,

  page: PropTypes.shape({
    pageType:  PropTypes.string,
    staffType: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  page: state.page?.selected,
});

export default connect(mapStateToProps)(BusinessRoutes);
